import alert from '@/plugins/alert'
import axios from '@/plugins/axios'
import { Uniform } from '@/plugins/api'
import { rangeRight } from 'lodash'

const UPLOAD_API = '/upload/'
const DESTROY_API = '/upload/files/'

export default {
  namespaced: true,
  state: {
    loading: false,
    uniformData: {},
    count: 0,
    search: [],
    pageText: '',
    itemsPerPage: 10,
    uniformSearchParams: {},
    totalItems: 0,
    uniformes: []
  },
  actions: {
    async searchUniformList({ commit, state, dispatch }, query) {
      const uniformSearchParams = {
        isDelete: false,
        _limit: state.itemsPerPage,
        ...query
      }
      commit('changeState', { uniformSearchParams })
      dispatch('requestPageSettings', {})
    },
    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      commit('changeState', { loading: true })
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.uniformSearchParams) {
        const uniformSearchParams = {
          ...state.uniformSearchParams,
          isDelete: false,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'name:ASC'
        }
        const [totalItems, uniformes] = await Promise.all([
          Uniform.count(uniformSearchParams),
          Uniform.search(uniformSearchParams)
        ])
        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            uniformes,
            totalItems,
            itemsPerPage,
            uniformSearchParams
          })
          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('setPageText', pageText)
        } else {
          var pages = rangeRight(1, page)
          for (let index = 0; index < pages; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
      commit('changeState', { loading: false })
    },
    uploadImage({ commit }, formData) {
      return axios
        .post(UPLOAD_API, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .catch(e => alert.error('Tải ảnh thất bại'))
    },
    destroyImage({ commit }, id) {
      return axios
        .delete(DESTROY_API + id)
        .catch(e => alert.error(e))
    },
    async createUniform({ commit, state }, uniformData) {
      try {
        const created = await Uniform.create(uniformData)
        commit('changeState', {
          uniformes: [created, ...state.uniformes]
        })
        return created
      } catch (e) {
        alert.error(e)
      }
    },
    async updateUniform({ commit, state }, { id, ...uniformData }) {
      const updated = await Uniform.update(id, uniformData)
      commit('updateUniform', updated)
      return updated
    },
    async removeUniform({ commit }, id) {
      await Uniform.remove(id)
      commit('removeUniform', id)
    },
    setUniform({ commit }, uniformData) {
      commit('setUniform', uniformData)
    }
  },
  mutations: {
    setPageText(state, pageText) {
      state.pageText = pageText
    },
    updateUniform(state, uniformData) {
      state.uniformes = state.uniformes.map(c => (uniformData._id === c._id ? uniformData : c))
    },
    removeUniform(state, id) {
      state.uniformes = state.uniformes.filter(d => d._id !== id)
    },
    changeState(state, payload) {
      Object.assign(state, payload)
    }
  },
  getters: {}
}
